import api from '@/apis'

export const fetchList = params => api.get(`/cashCoupon`, { params })
export const deleteCashCoupon = (id) => api.delete(`/cashCoupon/${id}`)
export const addCashCoupon = (data) =>  api.post(`/cashCoupon`, data)
export const updateCashCoupon = (id,data) =>  api.put(`/cashCoupon/${id}`, data)
